export default {
  title: '積分商城配置',
  productConfig: '商品配置',
};
